import React from 'react';
import { Typography } from '@mui/material';

const GeneratedSchemas = ({ schemas }) => {
  if (!Array.isArray(schemas) || schemas.length === 0) {
    return (
      <Typography variant="body2" color="textSecondary" sx={{ fontStyle: 'italic' }}>
        No schema available to display.
      </Typography>
    );
  }

  return (
    <div
      className="schemas-container"
      style={{
        padding: '1.5rem',
        backgroundColor: '#ffffff',
        borderRadius: '10px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)',
        margin: '1.5rem 0',
        border: '1px solid #f0f0f0',
        width: '100%',
        boxSizing: 'border-box',
        overflowX: 'auto',
      }}
    >
      {schemas.map((schemaObj, index) => (
        <div key={index} style={{ marginBottom: '1.5rem' }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 'bold', mb: 1, textTransform: 'capitalize' }}
          >
            {schemaObj['@type'] || 'Schema'} (#{index + 1})
          </Typography>

          <pre
            style={{
              padding: '1.25rem',
              backgroundColor: '#f8fafc',
              color: '#334155',
              borderRadius: '6px',
              fontSize: '14px',
              lineHeight: '1.5',
              overflowX: 'auto',
              fontFamily: 'Menlo, Monaco, Consolas, "Courier New", monospace',
              border: '1px solid #e2e8f0',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              maxWidth: '100%',
            }}
          >
            {JSON.stringify(schemaObj, null, 2)}
          </pre>
        </div>
      ))}
    </div>
  );
};

export default GeneratedSchemas;
